import type * as API from 'interfaces/api';
import type * as DB from 'interfaces/database';

export function findOfferingEditorMessages(
	editorMessages: ReadonlyArray<API.OfferingDataEditorMessageModel>,
	offeringId: DB.OfferingModel['id'],
): API.OfferingDataEditorMessageModel[] {
	return editorMessages
		.filter((editorMessage) => (
			editorMessage.offeringId === offeringId
		))
		.sort(sortOfferingEditorMessages);
}

function sortOfferingEditorMessages(
	editorMessage: API.OfferingDataEditorMessageModel,
	otherEditorMessage: API.OfferingDataEditorMessageModel,
): number {
	const scopeOrder = getEditorMessageScopeOrder(editorMessage.scope) - getEditorMessageScopeOrder(otherEditorMessage.scope);

	if (scopeOrder !== 0) {
		return scopeOrder;
	}

	const pageIndexOrder = getEditorMessagePageIndexOrder(editorMessage) - getEditorMessagePageIndexOrder(otherEditorMessage);

	if (pageIndexOrder !== 0) {
		return pageIndexOrder;
	}

	const messageIndexOrder = editorMessage.messageIndex - otherEditorMessage.messageIndex;

	if (messageIndexOrder !== 0) {
		return messageIndexOrder;
	}

	return editorMessage.id.localeCompare(otherEditorMessage.id);
}

function getEditorMessageScopeOrder(scope: API.OfferingDataEditorMessageScope): number {
	return scope === 'product' ? 0 : 1;
}

function getEditorMessagePageIndexOrder(editorMessage: API.OfferingDataEditorMessageModel): number {
	return editorMessage.scope === 'page'
		? editorMessage.pageIndex ?? Number.MAX_SAFE_INTEGER
		: 0;
}
